// extracted by mini-css-extract-plugin
var _1 = "MoreItem-moduleinfo__rNmoc";
var _2 = "MoreItem-moduleitem__ZclCs";
var _3 = "MoreItem-modulemoreItem__diPmo MultiValuedListMoreItem-moduleMultiValuedListMoreItem__SSTEE";
var _4 = "MoreItem-moduletext__GtrGV";
export { _1 as "info", _2 as "item", _3 as "moreItem", _4 as "text" }
